import React from 'react';

class CardBoutique extends React.Component {

    emptyCard() {
        return (
            <div className="card-boutique__any">{this.props.item.name}</div>
        )
    }

    cardContent() {
        return (
            <div className="w-full">
                <div className="card-boutique__image" style={{backgroundImage: "url(" + this.props.item.image + ")"}}></div>
                <div className="card-boutique__address">{this.props.item.name}</div>
                <div className="card-boutique__title">{this.props.item.adddress}</div>
            </div>
        )
    }

    render() {
        let cardClasses = 'card-boutique flex flex-col items-center justify-center';

        if (this.props.item.empty) {
            cardClasses += " any";
        }

        if (this.props.item.checked) {
            cardClasses += " checked";
        }
        
        return (
            <div className={cardClasses} onClick={this.props.changeHandler} >
                <div className="card-boutique__checked-icon"><i className="fas fa-check"></i></div>
                {
                    this.props.item.empty
                    ? this.emptyCard()
                    : this.cardContent()
                }
            </div>
        )
    }
}

export default CardBoutique;


// WEBPACK FOOTER //
// ./scripts/components/CardBoutique.jsx